import React, { useContext, useState, useEffect } from 'react';
import { Col, Row, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

import { Option } from 'antd/lib/mentions';
import { SelectMultiplo } from '../../components/SelectMultiplo';
import { MigracaoControle } from './MigracaoControle';

import * as S from './styles';
import { Context } from './context';

export function ListMigration({
  activeMigration,
  gettingTrue,
  migrationStatus,
}) {
  function Migrations() {
    const { setMigrations, isActiveMigrationSwitch } = useContext(Context);
    useEffect(() => {
      setMigrations(migrationStatus);
    }, [migrationStatus]);

    const [payload] = useState({
      id: 1,
      migracaoAtiva: isActiveMigrationSwitch,
      edicaoAutonomo: gettingTrue.autonomo?.some(
        item => item === 'edicaoAutonomo'
      ),
      cadastroAutonomo: gettingTrue.autonomo?.some(
        item => item === 'cadastroAutonomo'
      ),
      edicaoPropPFDistintos: gettingTrue.propPFDist?.some(
        item => item === 'edicaoPropPFDistintos'
      ),
      cadastroPropPFDistintos: gettingTrue.propPFDist?.some(
        item => item === 'cadastroPropPFDistintos'
      ),
      edicaoPropPFIguais: gettingTrue.propPFIguais?.some(
        item => item === 'edicaoPropPFIguais'
      ),
      cadastroPropPFIguais: gettingTrue.propPFIguais?.some(
        item => item === 'cadastroPropPFIguais'
      ),
      edicaoPropPJDistintos: gettingTrue.propPJDist?.some(
        item => item === 'edicaoPropPJDistintos'
      ),
      cadastroPropPJDistintos: gettingTrue.propPJDist?.some(
        item => item === 'cadastroPropPJDistintos'
      ),
      edicaoPropPJIguais: gettingTrue.propPJIguais?.some(
        item => item === 'edicaoPropPJIguais'
      ),
      cadastroPropPJIguais: gettingTrue.propPJIguais?.some(
        item => item === 'cadastroPropPJIguais'
      ),
      edicaoArrendatariosDistintos: gettingTrue.arrendDist?.some(
        item => item === 'edicaoArrendatariosDistintos'
      ),
      cadastroArrendatariosDistintos: gettingTrue.arrendDist?.some(
        item => item === 'cadastroArrendatariosDistintos'
      ),
      edicaoArrendatariosIguais: gettingTrue.arrendIguais?.some(
        item => item === 'edicaoArrendatariosIguais'
      ),
      cadastroArrendatariosIguais: gettingTrue.arrendIguais?.some(
        item => item === 'cadastroArrendatariosIguais'
      ),
    });
    const handleChange = e => {
      e.map(item => {
        payload[item] = true;
      });

      const newPlay = {
        ...payload,
        migracaoAtiva: isActiveMigrationSwitch,
      };
      return setMigrations(newPlay);
    };

    const handleDeselect = e => {
      payload[e] = false;
      setMigrations(payload);
    };

    function ColTitleList({ titulo, tooltip }) {
  return <Tooltip title={tooltip || ''}>
        <S.StyledColRow span={12} justify="center">
          {titulo || ''}
          <QuestionCircleOutlined
            style={{
              color: '#24a95d',
              marginLeft: 11,
            }}
          />
        </S.StyledColRow>
         </Tooltip>;
}

    return (
      <>
        <Row
          span={24}
          justify="center"
          style={{ borderBottom: '2px solid #cacaca' }}
        >
          <S.StyledColRowTitle span={12} justify="center">
            Nome
          </S.StyledColRowTitle>
          <S.StyledColRowTitle span={12} justify="center">
            Tipo
          </S.StyledColRowTitle>
        </Row>
        <Col>
          <Row span={24} justify="center">
            <ColTitleList
              titulo="Autônomo"
              tooltip="O motorista é o proprietário de todos os veículos."
            />
            <S.StyledColRow span={12} justify="center">
              <SelectMultiplo
                style={style}
                showArrow
                mode="multiple"
                onDeselect={handleDeselect}
                defaultValue={gettingTrue.autonomo}
                onChange={handleChange}
                placeholder="Selecione"
              >
                <Option value="cadastroAutonomo">Cadastro</Option>
                <Option value="edicaoAutonomo">Edição</Option>
              </SelectMultiplo>
            </S.StyledColRow>
          </Row>
          <Row span={24} justify="center">
            <ColTitleList
              titulo="Proprietários PF distintos"
              tooltip="Proprietários dos veículos (cavalo e carreta) são pessoas físicas diferentes"
            />
            <S.StyledColRow span={12} justify="center">
              <SelectMultiplo
                style={style}
                showArrow
                mode="multiple"
                onDeselect={handleDeselect}
                defaultValue={gettingTrue.propPFDist}
                onChange={handleChange}
                placeholder="Selecione"
              >
                <Option value="cadastroPropPFDistintos">Cadastro</Option>
                <Option value="edicaoPropPFDistintos">Edição</Option>
              </SelectMultiplo>
            </S.StyledColRow>
          </Row>
          <Row span={24} justify="center">
            <ColTitleList
              titulo="Proprietários PF iguais"
              tooltip="Proprietário dos veículos (cavalo e carreta) é uma única pessoa física."
            />
            <S.StyledColRow span={12} justify="center">
              <SelectMultiplo
                style={style}
                showArrow
                mode="multiple"
                onDeselect={handleDeselect}
                defaultValue={gettingTrue.propPFIguais}
                onChange={handleChange}
                placeholder="Selecione"
              >
                <Option value="cadastroPropPFIguais">Cadastro</Option>
                <Option value="edicaoPropPFIguais">Edição</Option>
              </SelectMultiplo>
            </S.StyledColRow>
          </Row>
          <Row span={24} justify="center">
            <ColTitleList
              titulo="Proprietários PJ Distintos"
              tooltip="Proprietários dos veículos (cavalo e carreta) são pessoas jurídicas diferentes."
            />
            <S.StyledColRow span={12} justify="center">
              <SelectMultiplo
                style={style}
                showArrow
                mode="multiple"
                onDeselect={handleDeselect}
                defaultValue={gettingTrue.propPJDist}
                onChange={handleChange}
                placeholder="Selecione"
              >
                <Option value="cadastroPropPJDistintos">Cadastro</Option>
                <Option value="edicaoPropPJDistintos">Edição</Option>
              </SelectMultiplo>
            </S.StyledColRow>
          </Row>
          <Row span={24} justify="center">
            <ColTitleList
              titulo="Proprietários PJ iguais"
              tooltip="Proprietário dos veículos (cavalo e carreta) é uma única pessoa jurídica."
            />
            <S.StyledColRow span={12} justify="center">
              <SelectMultiplo
                style={style}
                showArrow
                mode="multiple"
                onDeselect={handleDeselect}
                defaultValue={gettingTrue.propPJIguais}
                onChange={handleChange}
                placeholder="Selecione"
              >
                <Option value="cadastroPropPJIguais">Cadastro</Option>
                <Option value="edicaoPropPJIguais">Edição</Option>
              </SelectMultiplo>
            </S.StyledColRow>
          </Row>
          <Row span={24} justify="center">
            <ColTitleList
              titulo="Arrendatários Distintos"
              tooltip="Proprietários dos veículos (cavalo e carreta) são arrendatários diferentes."
            />
            <S.StyledColRow span={12} justify="center">
              <SelectMultiplo
                style={style}
                showArrow
                mode="multiple"
                onDeselect={handleDeselect}
                defaultValue={gettingTrue.arrendDist}
                onChange={handleChange}
                placeholder="Selecione"
              >
                <Option value="cadastroArrendatariosDistintos">
                  Cadastro
                </Option>
                <Option value="edicaoArrendatariosDistintos">Edição</Option>
              </SelectMultiplo>
            </S.StyledColRow>
          </Row>
          <Row span={24} justify="center">
            <ColTitleList
              titulo="Arrendatários iguais"
              tooltip="Proprietário dos veículos (cavalo e carreta) é um único arrendatário."
            />
            <S.StyledColRow span={12} justify="center">
              <SelectMultiplo
                style={style}
                showArrow
                mode="multiple"
                onDeselect={handleDeselect}
                defaultValue={gettingTrue.arrendIguais}
                onChange={handleChange}
                placeholder="Selecione"
              >
                <Option value="cadastroArrendatariosIguais">Cadastro</Option>
                <Option value="edicaoArrendatariosIguais">Edição</Option>
              </SelectMultiplo>
            </S.StyledColRow>
          </Row>
        </Col>
      </>
    );
  }

  return (
    <Col>
      <Col>
        <MigracaoControle activeMigration={activeMigration} />
      </Col>
      <Col
        style={{
          marginTop: 22,
        }}
      >
        <S.WrapperTable>
          <Migrations />
        </S.WrapperTable>
      </Col>
    </Col>
  );
}

const style = {
  width: '100%',
};
